import { server_connection } from 'config';
import { convertSidePanelFilterToProps } from '../../../tableSort/store/actions';
import { CONVERT_SIDE_PANEL_FILTER_TO_PROPS } from '../../../tableSort/store/actions';

export const INITIALIZE_FILTER = '[TABLE FILTER] INITIALIZE FILTER';
export const UPDATE_FILTER_COLUMN = '[TABLE FILTER] UPDATE FILTER COLUMN';
export const CHANGE_ARRAY_SWITCH = '[TABLE FILTER] CHANGE ARRAY SWITCH';
export const CLEAR_FILTER_STORE = '[TABLE FILTER] CLEAR FILTER STORE';

export function initializeFilters(dataList, component, columns) {
    return {
        type: INITIALIZE_FILTER,
        payload: {dataList, component, columns}
    }
}

export function changeArraySwitch(column_id) {
    return {
        type: CHANGE_ARRAY_SWITCH,
        payload: {column_id}
    }
}

export function updateFilterColumn(column, value) {
    return {
        type: UPDATE_FILTER_COLUMN,
        payload: {column, value}
    }
}

export function saveTableFilter(auth_id, table_name, filter_list) {
    return (dispatch) => {
        fetch(server_connection + '/utility/table/set_side_filter',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ auth_id, table_name, filter_list })
            })
            .then((response) => {
                dispatch({
                    type: CONVERT_SIDE_PANEL_FILTER_TO_PROPS,
                    payload: { table_name, filter_list },
                })
            })
    }
}

export function clearFilterStore() {
    return {
        type: CLEAR_FILTER_STORE,
        payload: {}
    }
}


// WEBPACK FOOTER //
// src/main/components/tableFilter/store/actions/table_filter.actions.js